import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,LoadingController } from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { FaqPostPage } from '../faq-post/faq-post';

/**
 * Generated class for the FaqPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-faq',
  templateUrl: 'faq.html',
})
export class FaqPage {
  aboutUsContent: any;
  faqContent: any;

  constructor(
    private loadingCtrl:LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    private cp : CommonProvider) {
  }

  ionViewDidLoad() {
    //console.log('ionViewDidLoad LoginPage');
  this.getAboutUsContent()
  }
  getAboutUsContent(){
let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
  
  let data = this.cp.getFaqDetails(loading) ;
  data.then((res:any)=>{
    loading.dismiss()
    var res=JSON.parse(res)
     this.faqContent = res.Payload.ibhfl_faqs;
     ////console.log(this.aboutUsContent);
     
  })
}
handleInput(ev){
  console.log(ev.target.value);
  if(ev.target.value){
    this.faqContent = this.faqContent.filter(o=>
      Object.keys(o).some(k => o[k].toLowerCase().includes(ev.target.value.toLowerCase()))
      // obj.ibhfl_question.toLowerCase()===ev.target.value.toLowerCase()
      );
  }else{
    this.getAboutUsContent()
  }
  

}
goToPostFaqPage(action){
  this.navCtrl.push(FaqPostPage,action);
}

}



// WEBPACK FOOTER //
// ./src/pages/faq/faq.ts